import { Card, CardBody } from '@apollo/orbit';
import classnames from 'classnames';
import React from 'react';

export const ChampionDashboardCard = ({
  className,
  children,
}: {
  className?: string;
  children: React.ReactNode;
}) => <Card className={classnames(className, 'h-80')}>{children}</Card>;

export const ChampionDashboardCardBody = ({
  children,
}: {
  children: React.ReactNode;
}) => <CardBody className="min-h-40">{children}</CardBody>;
